import { makeStyles } from "@saleor/macaw-ui";

export const useGiftCardDeleteDialogContentStyles = makeStyles(
  () => ({
    progressContainer: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
    },
  }),
  { name: "GiftCardDeleteDialogContent" },
);
